// extracted by mini-css-extract-plugin
export var actionButton = "_ar-1";
export var actionButtons = "_ar-2";
export var actions = "_ar-0";
export var aiUnread = "_ar-10";
export var alignCenter = "_ar-h";
export var backWrapper = "_ar-3";
export var cellContainer = "_ar-4";
export var checkboxContainer = "_ar-5";
export var contentContainer = "_ar-6";
export var contentHeader = "_ar-8";
export var conversationsTableWrapper = "_ar-s";
export var draftReplyBadgeContainer = "_ar-m";
export var dropdownItem = "_ar-b";
export var dropdownItemsContainer = "_ar-a";
export var dropdownTitle = "_ar-c";
export var errorIcon = "_ar-7";
export var filter = "_ar-d";
export var gray = "_ar-i";
export var headerActionButtons = "_ar-e";
export var headerCheckboxContainer = "_ar-f";
export var icon = "_ar-j";
export var menuContainer = "_ar-k";
export var noMoreTicketsIcon = "_ar-12";
export var noMoreTicketsSubText = "_ar-13";
export var oneLine = "_ar-l";
export var optionsButton = "_ar-n";
export var plus = "_ar-o";
export var portalButtonsWrapper = "_ar-g";
export var red = "_ar-p";
export var scrolledTop = "_ar-9";
export var search = "_ar-q";
export var selectedConversationsCount = "_ar-r";
export var spinner = "_ar-t";
export var strong = "_ar-u";
export var summaryCell = "_ar-v";
export var tableContainer = "_ar-11";
export var tagContainer = "_ar-w";
export var threeDots = "_ar-x";
export var twoLines = "_ar-y";
export var unread = "_ar-z";